/* eslint-disable react/no-array-index-key */
import React from 'react';
import cx from 'clsx';

import type { OAISchema } from '~/types/openapi';

import { SafeDeliveryWithTextIcon, Text택배배송Icon } from '~/assets/icons';

type Props = {
  flags?: OAISchema['MarketSelectProductResponseV2']['deliveryFlags'];
  className?: string;
};
function DeliveryFlag({ flags = [], className }: Props) {
  if (!flags || flags.length === 0) return <></>;

  return (
    <div className={cx('mt-[6px]', className)}>
      {flags.map((flag) => {
        switch (flag) {
          case 'COURIER':
            return <Text택배배송Icon key={flag} className={className} />;
          case 'SAFE_DELIVERY':
            return (
              <SafeDeliveryWithTextIcon key={flag} className={className} />
            );
          case 'NONE':
          default:
            return null;
        }
      })}
    </div>
  );
}

export default DeliveryFlag;
